import DefaultLayout from './defaultLayout';

export const PageWithLayout = (Wrapped) =>
  DefaultLayout(Wrapped);

export default PageWithLayout;